import { CountryType, SocialType, StepType } from "types";

import Allergy from "assets/data/allergy.json";
import Country from "assets/data/country.json";
import Cuisine from "assets/data/cuisine.json";
import Configuration from "assets/data/configuration.json";
import NoGo from "assets/data/no_go.json";
import Potluck from "assets/data/potluck.json";
import Preference from "assets/data/preference.json";
import Social from "assets/data/social.json";
import Step from "assets/data/step.json";
import User from "assets/data/user.json";

export const StepConfig = Step as unknown as StepType[];
export const SocialConfig = Social as unknown as SocialType;

export const Allergies = Allergy as unknown as string[];
export const Countries = Country as unknown as CountryType[];
export const Cuisines = Cuisine as unknown as string[];
export const NoGoes = NoGo as unknown as string[];

export const Configurations = Configuration as unknown as any[];
export const Potlucks = Potluck as unknown as any[];
export const Preferences = Preference as unknown as any[];
export const Users = User as unknown as any[];